import capitalize from 'lodash-es/capitalize';

type FormatLabelOptions = {
  preserveCase?: boolean;
  uppercaseAcronyms?: string[];
};

export const formatLabel = (
  label: string,
  options: FormatLabelOptions = {}
) => {
  let words = label.split('_').join(' ');
  words = options.preserveCase ? words : capitalize(words);
  return words
    .split(' ')
    .map((s) =>
      options.uppercaseAcronyms
        ?.map((a) => a.toUpperCase())
        .includes(s.toUpperCase())
        ? s
            .split('')
            .map((p) => p.toUpperCase())
            .join('')
        : s
    )
    .join(' ');
};
